import React, { useState, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import './Login.css';

export default function Login() {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const usernameRef = useRef(null);
  const passwordRef = useRef(null);

  const clearValidity = () => {
    if (usernameRef.current) usernameRef.current.setCustomValidity('');
    if (passwordRef.current) passwordRef.current.setCustomValidity('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    clearValidity();
    setSubmitting(true);
    try {
      await login(username.trim(), password);
    } catch (err) {
      const msg = err.message || 'Ошибка входа';
      if (passwordRef.current) {
        passwordRef.current.setCustomValidity(msg);
        passwordRef.current.reportValidity();
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <form onSubmit={handleSubmit} className="login-form" noValidate>
          <input
            ref={usernameRef}
            name="username"
            type="text"
            placeholder="Логин"
            value={username}
            onChange={(e) => {
              setUsername(e.target.value);
              clearValidity();
            }}
            className="login-input"
            autoComplete="username"
            required
          />
          <input
            ref={passwordRef}
            name="password"
            type="password"
            placeholder="Пароль"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              clearValidity();
            }}
            className="login-input"
            autoComplete="current-password"
            required
          />
          <button type="submit" className="login-button" disabled={submitting}>
            {submitting ? 'Вход…' : 'Войти'}
          </button>
        </form>
      </div>
    </div>
  );
}
